import { routes } from "../routing/routes";
import KitchenIcon from "@mui/icons-material/Kitchen";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import LocationCityIcon from "@mui/icons-material/LocationCity";



export const CampusNavTabs = [
  {
    id: "campusPods",
    label: "Campus Pods",
    icon: <KitchenIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.CAMPUS_PODS,
  },
   {
    id: "campusUsers",
    label: "User Management",
    icon: <AccountBoxIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.CAMPUS_USERS,
  },
  //   {
  //   id: "campusTransaction",
  //   label: "User Transactions",
  //   icon: <LocationCityIcon sx={{ fontSize: 25 }} />,
  //   tabUrl: routes.CAMPUS_TRANSACTION,
  // },
  
];
